<template>
    <div class="rating-stars">
        <ul>
            <li
                v-for="n in parseInt(filledStars)"
                :key="n"
            >
                <icon-star :width="17" :height="14"/>
            </li>

            <li
                v-for="o in parseInt(maxRating - filledStars)"
                :key="o"
            >
                <icon-star-outlined />
            </li>
        </ul>

        <span v-if="!hideRating">{{rating}}</span>
    </div>
</template>

<script>
import { computed } from 'vue';
import IconStar from '@/components/icons/icon-star/icon-star';
import IconStarOutlined from '@/components/icons/icon-star-outlined/icon-star-outlined';

export default {
    name: 'rating-stars',

    components: {
        IconStar,
        IconStarOutlined,
    },

    props: {
        maxRating: {
            type: Number,
            default: 5
        },
        rating: {
            type: [String, Number],
            default: ''
        },
        hideRating: {
            type: Boolean,
            default: false
        }
    },

    setup(props) {
        const filledStars = computed(() => Math.floor(props.rating))

        return {
            filledStars,
            maxRating: computed(() => props.maxRating)
        }
    }
}
</script>
